import * as React from 'react';
import {Button, ButtonGroup} from 'reactstrap';
import validate from './validate';
import Panel from '../../../../theme/components/Panel';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import renderSelectField from '../../../../theme/components/form/Select';
import {FuerzasVenta} from '../../../../utils/constants';

interface PrioritariosConfFormState {
    fuerzasVenta: object[];
}

class PrioritariosConfForm extends React.PureComponent<InjectedFormProps, PrioritariosConfFormState> {

    constructor(props, state) {
        super(props, state);
        this.state = {
            fuerzasVenta: [
                {value: FuerzasVenta.GLORIA_NORTE.id, label: FuerzasVenta.GLORIA_NORTE.descripcion},
                {value: FuerzasVenta.SAN_FERNANDO.id, label: FuerzasVenta.SAN_FERNANDO.descripcion},
                {value: FuerzasVenta.KIMBERLY.id, label: FuerzasVenta.KIMBERLY.descripcion},
                {value: FuerzasVenta.NEXO.id, label: FuerzasVenta.NEXO.descripcion},
                {value: FuerzasVenta.STANLEY.id, label: FuerzasVenta.STANLEY.descripcion},
                {value: FuerzasVenta.AUREN2.id, label: FuerzasVenta.AUREN2.descripcion}
            ]
        };
    };

    public render() {
        const {handleSubmit} = this.props;
        return (
            <Panel xs={12} md={12} divider={true} title='Filtros'>
                <form className='form' onSubmit={handleSubmit}>
                    <div className='form__form-group'>
                        <label className='form__form-group-label'>Fuerza de Venta: </label>
                        <div className='form__form-group-field'>
                            <Field
                                name='fuerzaVentaId'
                                component={renderSelectField}
                                placeholder='Seleccione'
                                type='text'
                                options={this.state.fuerzasVenta}
                            />
                        </div>
                    </div>
                    <ButtonGroup className='btn-group--justified'>
                        <Button color='success' type='submit'>FILTRAR</Button>
                    </ButtonGroup>
                </form>
            </Panel>
        );
    }
}

export default reduxForm({
    form: 'prioritarios_conf_form', // a unique identifier for this form
    validate
})(PrioritariosConfForm);




// WEBPACK FOOTER //
// ./src/components/pages/prioritarios/configuracion/prioritarios-conf-form.tsx